import { Suspense } from 'react'

import axios from 'axios'
import { ConnectedRouter } from 'connected-react-router'
import { createBrowserHistory as createHistory } from 'history'
import { I18nextProvider } from 'react-i18next'
import { Provider } from 'react-redux'
import { Route } from 'react-router-dom'
import ReactDOM from 'react-dom'

import ManagerActions from './actions/ManagerActions'
import App from './containers/AppContainer'
// Store imports
import i18n from './i18n'
import unregister from './registerServiceWorker'
import configureStore from './store/configureStore'

import LoaderFullScreen from 'components/LoaderFullScreen/LoaderFullScreen'

// Set global variables
const {
  NODE_ENV,
  REACT_APP_DEV_API,
  REACT_APP_DEV_EDUBOOK_URL,
  REACT_APP_DEV_RESOURCES_FLIPBOOK_URL,
  REACT_APP_DEV_RESOURCES_ICPLAYER_HOST,
  REACT_APP_DEV_RESOURCES_MAUTHOR_HOST,
  REACT_APP_DEV_RESOURCES_MAUTHOR_URL,
  REACT_APP_PROXY,
} = process.env

if (NODE_ENV === 'development' && REACT_APP_PROXY) {
  // URL's config for development purposes
  let ext
  switch (REACT_APP_PROXY) {
    case 'PRO':
      ext = 'com'
      break
    case 'PRE':
      ext = 'pre'
      break
    default:
      ext = 'devel'
      break
  }
  window.viewer.api = REACT_APP_PROXY ? REACT_APP_DEV_API : window.viewer.api
  window.viewer.edubookDigital = window.viewer.edubookDigital.replace(/\.local/, `.${ext}`)
  window.viewer.edubookUrl = REACT_APP_DEV_EDUBOOK_URL
  window.viewer.help = window.viewer.help.replace(/\.local/, `.${ext}`)
  window.viewer.icPlayerHost = REACT_APP_DEV_RESOURCES_ICPLAYER_HOST
  window.viewer.mauthorHost = REACT_APP_DEV_RESOURCES_MAUTHOR_HOST
  window.viewer.path = REACT_APP_PROXY ? '/' : window.viewer.path
  window.viewer.resourcesFlipbookApi = REACT_APP_DEV_RESOURCES_FLIPBOOK_URL
  window.viewer.resourcesMauthorApi = REACT_APP_DEV_RESOURCES_MAUTHOR_URL
  window.viewer.resourceUrl = window.viewer.resourceUrl.replace(/\.local/, `.${ext}`)
  window.viewer.url = window.viewer.url.replace(/\.local/, `.${ext}`)
  if (ext !== 'com') {
    window.viewer.apiTracking = window.viewer.apiTracking.replace(/https/, 'http')
    window.viewer.apiTracking = window.viewer.apiTracking.replace(/\.com/, `.${ext}`)
    window.viewer.grafanaFaroUrl = window.viewer.grafanaFaroUrl.replace(/https/, 'http')
  }
}

// Config store and save into window
const store = configureStore()

// Create a history of your choosing (we're using a browser history in this case)
const history = createHistory({ basename: window.viewer.path })

axios.interceptors.request.use(
  (request) => {
    store.dispatch(ManagerActions.incrementLoader())
    return request
  },
  (asyncError) => {
    store.dispatch(ManagerActions.updateError(asyncError))
    store.dispatch(ManagerActions.resetLoader())
    return Promise.reject(asyncError)
  }
)

axios.interceptors.response.use(
  (response) => {
    if (response.data.logged === false) {
      const referral = encodeURIComponent(window.location.href)
      window.location = `${window.viewer.edubookLogin}?rf=${referral}`
    }
    store.dispatch(ManagerActions.decrementLoader())
    return response
  },
  (asyncError) => {
    store.dispatch(ManagerActions.resetLoader())
    store.dispatch(ManagerActions.updateError(asyncError))
    return Promise.reject(asyncError)
  }
)

function Index() {
  return (
    <I18nextProvider i18n={i18n}>
      <Provider store={store}>
        <ConnectedRouter history={history}>
          <Suspense fallback={<LoaderFullScreen />}>
            <Route path='/*' render={(props) => <App {...props} />} />
          </Suspense>
        </ConnectedRouter>
      </Provider>
    </I18nextProvider>
  )
}

ReactDOM.render(<Index />, document.getElementById('root'))

unregister()
